import React from 'react'

export default props => (
	<div className='card' style={{ ...props.style }} onClick={props.onClick}>
		{props.children}
	</div>
)
